










import BackgroundFilesGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFilesGetListResponse";
import BackgroundFileItem from "@/models/components/backgroundFileItem";
import { Component, Vue, Model, Watch, Prop } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component
export default class UiBackgroundFileDropdownComponent extends Vue {
  @Model("onSelected", { type: String, default: null }) value: string;
  innerValue: string = null;
  files: BackgroundFileItem[] = [];
  originalFiles: BackgroundFilesGetListResponse[] = [];
  error: boolean = false;
  watchError:boolean = false;
  @Watch("value")
  onValueChanged() {
    this.innerValue = this.value;
    if(this.watchError) {
      this.isValid();
    }
  }
  emit() {
    this.$emit("onSelected", this.innerValue);
    this.$emit(
      "onBackgroundChoose",
      this.originalFiles.find((x) => x.Id == this.innerValue)
    );
  }
  @Watch("innerValue")
  onInnerValueChanged() {
    this.emit();
  }
  @Watch("files")
  onFilesChanged() {
    this.emit();
  }
  async created() {
    this.innerValue = this.value;
    const res = await this.$api.BackgroundFileService.getListAsync({
      Pagination: { Skip: null, Take: null },
      Search: null,
      Sort: null,
    });
    this.originalFiles = res.Items;
    this.files = [
      { id: null, name: "Выберите фоновый файл" },
      ...res.Items.map((x) => new BackgroundFileItem(x)),
    ];
  }
  isValid(): boolean {
    this.watchError = true;
    this.error = this.value?false:true;
    return !this.error;
  }
}
